/**
 * <s-sticky-buy data-target="element-id">
 * Mobile purchase bar: shows itself once the element named by data-target
 * (the main buy buttons) has scrolled above the viewport, and hides again
 * when the shopper scrolls back to it. Inert while hidden.
 */
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.getElementById(this.dataset.target);
    if (!target) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', SStickyBuy);
}
